import type { WidgetSkeletonProps } from '../widget-registry';

export function EventListSkeleton({ count = 2 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-3">
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className="flex h-[74px] items-center justify-between rounded-[16px] border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-800"
        >
          <div className="flex min-w-0 flex-col gap-2">
            <div className="h-4 w-56 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
            <div className="h-3 w-40 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
          </div>
          <div className="ml-3 h-5 w-5 flex-shrink-0 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
        </div>
      ))}
    </div>
  );
}

export default function OpenHouseDatesSkeleton(_props: WidgetSkeletonProps) {
  return (
    <div>
      <div className="mb-4 flex items-start gap-3">
        <div className="h-5 w-5 flex-shrink-0 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
        <div className="flex-1 space-y-2">
          <div className="h-5 w-36 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
          <div className="h-4 w-40 animate-pulse rounded bg-gray-200 dark:bg-gray-600" />
        </div>
      </div>
      <EventListSkeleton />
    </div>
  );
}
